import { useEffect, useRef, useCallback } from "react";

const IDLE_TIMEOUT = 5 * 60 * 1000; // 5 minutes

const useIdleLogout = (logoutUser) => {
    const timeoutRef = useRef(null);

    const resetTimer = useCallback(() => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);

        timeoutRef.current = setTimeout(() => {
            handleLogout();
        }, IDLE_TIMEOUT);
    }, []);

    const handleLogout = useCallback(() => {
        console.log("User has been idle for too long. Logging out...");
        logoutUser();
    }, []);

    useEffect(() => {
        const events = ["mousemove", "mousedown", "keypress", "keydown", "scroll", "click"];

        const handleActivity = () => {
            resetTimer();
        };

        // Attach listeners
        events.forEach((event) =>
            window.addEventListener(event, handleActivity)
        );

        // Start the timer initially
        resetTimer();

        return () => {
            // Clean up listeners on unmount
            events.forEach((event) =>
                window.removeEventListener(event, handleActivity)
            );
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, [resetTimer]);

  return null; // This is a hook, no UI
};

export default useIdleLogout;